export default __webpack_public_path__ + "static/discord-ab93e40ef1a6d9095135414ed6b05f95.svg";